import { CandleStickBar } from '../../types/entities';

export interface HistoricalDataStateByKey {
  loading: boolean;
  loaded: boolean;
  error?: string;
  bars: CandleStickBar[];
  cachedTimestamp: number;
}

export const initialHistoricalDataStateByKey: HistoricalDataStateByKey = {
  loading: false,
  loaded: false,
  error: undefined,
  bars: [],
  cachedTimestamp: 0
};

export interface HistoricalDataState {
  [key: string]: HistoricalDataStateByKey;
}

export const initialHistoricalDataState: HistoricalDataState = {};
